import { useQuery } from '@tanstack/react-query';
import { FeatureFlagsApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function useFeatureFlagsQueryControllerGetNonDeletedFeatureFlagsQuery(args, options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useQuery({
        queryKey: ['featureFlagsQueryControllerGetNonDeletedFeatureFlags', accessControlScope, args],
        queryFn: async () => {
            const api = new FeatureFlagsApi(accessControlConfig);
            return api.featureFlagsQueryControllerGetNonDeletedFeatureFlags(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=useFeatureFlagsQueryControllerGetNonDeletedFeatureFlagsQuery.js.map